import WithDefaultOptionHelper from "../WithDefaultOptionHelper";
import UiMeet3dLevel from "~/constants/UiMeet3d/UiMeet3dLevel";

const tourUiMeet3dLevelOptions = [
  { value: UiMeet3dLevel.NONE, key: "none", text: "clientPanelConstants:uiMeet3dLevelNone" },
  {
    value: UiMeet3dLevel.MULTI_USER,
    key: "multiUser",
    text: "clientPanelConstants:uiMeet3dLevelMultiUser",
  },
  { value: UiMeet3dLevel.CHAT, key: "chat", text: "clientPanelConstants:uiMeet3dLevelChat" },
  { value: UiMeet3dLevel.VIDEO, key: "video", text: "clientPanelConstants:uiMeet3dLevelVideo" },
];

export default WithDefaultOptionHelper(tourUiMeet3dLevelOptions);
